import { ScannersWrapper } from '../../components'
import AuthService from '../../utilities/services/auth.service'

export default function ScannersPage() {
  const organization = AuthService.getOrg()?.[0]
  return <ScannersWrapper organization={organization} />
}
